import { defineDirective } from "../../utils/angular"
import { isNumber } from "../../utils/utils"

interface View {
    id: string | number
    text: string
    icon?: string
}

/** @internal */
export class ViewSelect {

    static create() {

        return defineDirective(ViewSelect, "shared/components/viewSelect/vs.html", {
            views: "<",
            view: "=",
            left: "<",
            buttonWidth: "<",
            disabled: "<",
            onChange: "<",
            minWidth: "<"
        })

    }

    private _dispose: Function = () => { }

    public left: number
    public buttonWidth: number

    public views: View[]
    private _viewId: string | number
    private _viewObj: View

    public disabled: boolean

    private windowWidth: number
    private _minWidth: number

    public onChange: (view: string | number) => void

    static $inject = ["$scope", "$window"]

    constructor(private readonly $scope: ng.IScope, private readonly $window: ng.IWindowService) {
    }

    $onInit() {

        this.minWidth = isNumber(this.minWidth) ? this.minWidth : 1300

        const handler = () => {
            const b = this.collapsed
            this.windowWidth = this.$window.innerWidth
            const a = this.collapsed
            if (a != b) {
                this.$scope.$applyAsync()
            }
        }

        this._dispose()

        this.$window.addEventListener("resize", handler)

        this._dispose = () => this.$window.removeEventListener("resize", handler)

        handler()

    }

    $onDestroy() {
        this._dispose()
    }

    get minWidth() {
        return this._minWidth
    }

    set minWidth(value) {
        this._minWidth = value
    }

    get collapsed() {
        return this._minWidth && this.windowWidth && (this.windowWidth < this._minWidth)
    }

    get view() {
        return this._viewId
    }

    set view(id: string | number) {
        const v = (this.views || []).find(v => v.id == id)
        this.selectView(v)
    }

    get viewObj() {
        return this._viewObj
    }

    selectView(view: View) {
        this._viewId = view?.id
        this._viewObj = view
        this.onChange && this.onChange(this.view)
    }

    getButtonStyle(dropdown = false) {

        if (this.buttonWidth) {
            return {
                width: (this.buttonWidth + (dropdown ? 20 : 0)) + "px"
            }
        }
    }

    getStyle() {

        if (this.left) {
            return {
                left: this.left + "px"
            }
        }
    }

}
